import {
  GET_JOURNAL_DAYS,
  GET_JOURNAL_DAYS_SUCCESS,
  GET_JOURNAL_DAYS_FAIL,

  GET_JOURNAL_BY_DAY,
  GET_JOURNAL_BY_DAY_SUCCESS,
  GET_JOURNAL_BY_DAY_FAIL,

  CREATE_JOURNAL_ENTRY,
  CREATE_JOURNAL_ENTRY_SUCCESS,
  CREATE_JOURNAL_ENTRY_FAIL,

  UPDATE_JOURNAL_ENTRY,
  UPDATE_JOURNAL_ENTRY_SUCCESS,
  UPDATE_JOURNAL_ENTRY_FAIL,

  DELETE_JOURNAL_ENTRY,
  DELETE_JOURNAL_ENTRY_SUCCESS,
  DELETE_JOURNAL_ENTRY_FAIL,

  GET_JOURNAL_TIMELINE,
  GET_JOURNAL_TIMELINE_SUCCESS,
  GET_JOURNAL_TIMELINE_FAIL,
} from "./actionTypes"

// GET #1: list days with notes
export const getJournalDays = () => ({ type: GET_JOURNAL_DAYS })
export const getJournalDaysSuccess = days => ({ type: GET_JOURNAL_DAYS_SUCCESS, payload: days })
export const getJournalDaysFail = error => ({ type: GET_JOURNAL_DAYS_FAIL, payload: error })

// GET #2: fetch notes for a day
export const getJournalByDay = day => ({ type: GET_JOURNAL_BY_DAY, payload: day })
export const getJournalByDaySuccess = notes => ({ type: GET_JOURNAL_BY_DAY_SUCCESS, payload: notes })
export const getJournalByDayFail = error => ({ type: GET_JOURNAL_BY_DAY_FAIL, payload: error })

// CREATE
export const createJournalEntry = data => ({ type: CREATE_JOURNAL_ENTRY, payload: data })
export const createJournalEntrySuccess = created => ({ type: CREATE_JOURNAL_ENTRY_SUCCESS, payload: created })
export const createJournalEntryFail = error => ({ type: CREATE_JOURNAL_ENTRY_FAIL, payload: error })

// UPDATE
export const updateJournalEntry = data => ({ type: UPDATE_JOURNAL_ENTRY, payload: data })
export const updateJournalEntrySuccess = updated => ({ type: UPDATE_JOURNAL_ENTRY_SUCCESS, payload: updated })
export const updateJournalEntryFail = error => ({ type: UPDATE_JOURNAL_ENTRY_FAIL, payload: error })

// DELETE
export const deleteJournalEntry = noteId => ({ type: DELETE_JOURNAL_ENTRY, payload: noteId })

// TIMELINE
export const getJournalTimeline = payload => ({ type: GET_JOURNAL_TIMELINE, payload })
export const getJournalTimelineSuccess = notes => ({ type: GET_JOURNAL_TIMELINE_SUCCESS, payload: notes })
export const getJournalTimelineFail = error => ({ type: GET_JOURNAL_TIMELINE_FAIL, payload: error })
export const deleteJournalEntrySuccess = noteId => ({ type: DELETE_JOURNAL_ENTRY_SUCCESS, payload: noteId })
export const deleteJournalEntryFail = error => ({ type: DELETE_JOURNAL_ENTRY_FAIL, payload: error })
